import * as React from 'react';
import { observer } from 'mobx-react';
import { ITranslationsCollection, translate } from '@estee/elc-service';
import { INFO_POPUP_TRIGGER } from '../constants/AutoReplenishment';
import { classes } from '../utils/Classes';
import { Button } from '@estee/elc-buttons';
import { InfoIcon } from '@estee/elc-icons';

export interface AutoReplenishInfoModalTriggerOptions {
    translations?: ITranslationsCollection;
    triggerType?: INFO_POPUP_TRIGGER;
    onClick(): void;
}

export const AutoReplenishmentInfoModalTrigger = translate([
    'learnMoreLabel',
    'openLabel',
    'closeLabel',
    'autoReplenishMoreInformation'
])(
    observer((props: AutoReplenishInfoModalTriggerOptions) => {
        const { translations, triggerType } = props;

        const openModalClassNames = classes('auto-replenish-open-modal');
        const autoReplenishModalTriggerIconClass = classes('auto-replenish-modal-trigger-icon');
        const autoReplenishModalTriggerTextClass = classes('auto-replenish-modal-trigger-text');

        const {
            openLabel,
            learnMoreLabel,
            autoReplenishMoreInformation
        } = translations as ITranslationsCollection;

        const infoModalButtonContent =
            triggerType === INFO_POPUP_TRIGGER.TEXT ? (
                <span className={autoReplenishModalTriggerTextClass}>{learnMoreLabel}</span>
            ) : (
                <InfoIcon className={autoReplenishModalTriggerIconClass} />
            );

        return (
            <Button
                onClick={props.onClick}
                className={openModalClassNames}
                aria-label={`${openLabel} ${autoReplenishMoreInformation}`}
                title={`${openLabel} ${autoReplenishMoreInformation}`}
            >
                {infoModalButtonContent}
            </Button>
        );
    })
);
